import { render, staticRenderFns } from "./tos.vue?vue&type=template&id=0e1df5ea&"
import script from "./tos.vue?vue&type=script&lang=tsx&"
export * from "./tos.vue?vue&type=script&lang=tsx&"
import style0 from "./tos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports